module.exports = __webpack_public_path__ + "static/media/KW.398bcf75.svg";